

































































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {State} from "vuex-class";
import {NabavkaVozila, Vozilo} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service';
import {TabBase} from "@/views/Vozila/PodaciVozila/TabBase";

@Component({})
export default class Tab3 extends TabBase {
    @State vozilo!: Vozilo;
    nabavka = new NabavkaVozila();

    @Watch('vozilo') async onVoziloChanged(vozilo: Vozilo) {
        this.nabavka = await dataProxy.vratiNabavkuVozila(vozilo.id || 0);
    }

    async handleSave() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            this.nabavka.voziloId = this.vozilo.id;
            this.nabavka.voziloId = await this.saveData(() => dataProxy.sacuvajNabavkuVozila(this.vozilo.id, this.nabavka))();
        }
    }

    async handleDelete() {
        if (this.nabavka.voziloId) {
            const da = await this.confirmationNeeded('da li zeliete da obrisete podatke o nabavci vozila');
            if (da) {
                await this.saveData(() => dataProxy.obrisiNabavkuVozila(this.nabavka.voziloId))();
                this.nabavka = new NabavkaVozila();
            }
        }
    }

    @Watch('nabavka.brojMeseciOtplate')
    @Watch('nabavka.nabavnaCena')
    @Watch('nabavka.ucesce')
    onBrojMeseciOtplateChanged() {
        this.izracunajMesecnuRatu();
    }

    private izracunajMesecnuRatu() {
        this.nabavka.mesecnaRata =
            Math.round((this.nabavka.brojMeseciOtplate || 0)
                ? ((this.nabavka.nabavnaCena || 0) - (this.nabavka.ucesce || 0)) / (this.nabavka.brojMeseciOtplate || 0)
                : 0);
    }
}
